import Compressor from 'compressorjs'

const quality = 0.6

export const compressImage = (image) =>
  new Promise((resolve, reject) => {
    new Compressor(image, {
      quality,
      success(result) {
        resolve(result)
      },
      error(err) {
        reject(err)
      },
    })
  })
